import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import ClientComponents from '@components/ClientComponents';
import Swiper from '@components/Swiper';
import ProductCardContainer, {
  getProductCardProps,
} from '@results/HOCs/ProductCardContainer';
import SwimlaneCardContainer from '@results/HOCs/SwimlaneCardContainer';
import { SWIMLANES } from '@shopDetails/constants';
import Subtitle from './components/Subtitle';
import DiscountProduct from './components/DiscountProduct';
import messages from './messages';

const MIN_QUANTITY = 1;

const DiscountsProducts = ({
  products,
  position,
  intl: { formatMessage },
  onBeforeProductConfig,
  trackSwimlane,
  trackSwimlaneSwiped,
}) => {
  const isEmpty = products.length <= MIN_QUANTITY;

  useEffect(() => {
    if (!isEmpty) {
      trackSwimlane(products, SWIMLANES.DISCOUNTS, position);
    }
  });

  if (isEmpty) return null;

  const handleOnScrollFinish = currentIndex => {
    trackSwimlaneSwiped({
      title: SWIMLANES.DISCOUNTS,
      type: 'product',
      screenType: 'shop_details',
      position: currentIndex,
      products,
    });
  };

  return (
    <>
      <Subtitle label={formatMessage(messages.title)} separator={false} />
      <ClientComponents>
        <Swiper id="discounts" onScrollFinish={handleOnScrollFinish}>
          {products.map((product, index) => (
            <ProductCardContainer
              key={product.id}
              {...getProductCardProps(product)}
              onBeforeProductConfig={onBeforeProductConfig}
            >
              {onProductClick => (
                <SwimlaneCardContainer
                  onClick={onProductClick}
                  swimlane={{ code: SWIMLANES.DISCOUNTS }}
                  swimlanePosition={position}
                  item={product}
                  positionItem={index}
                >
                  {onClick => (
                    <DiscountProduct
                      onClick={onClick}
                      product={product}
                      menuSection={`widget_${SWIMLANES.DISCOUNTS}`}
                    />
                  )}
                </SwimlaneCardContainer>
              )}
            </ProductCardContainer>
          ))}
        </Swiper>
      </ClientComponents>
    </>
  );
};

DiscountsProducts.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
      applyDiscount: PropTypes.bool,
      price: PropTypes.number,
      finalPriceWithoutTaxes: PropTypes.number,
      priceWithDiscount: PropTypes.number,
      subsidizedProduct: PropTypes.object,
      image: PropTypes.string,
    }),
  ).isRequired,
  onBeforeProductConfig: PropTypes.func.isRequired,
  trackSwimlane: PropTypes.func.isRequired,
  trackSwimlaneSwiped: PropTypes.func.isRequired,
  position: PropTypes.number,
  intl: intlShape,
};

export default injectIntl(DiscountsProducts);
